// @ts-nocheck

class CustomPrice extends HTMLElement {
    constructor() {
        super();
        
        this.regularPriceEl = this.querySelector('.regular-price');
        this.launchPrice = this.closest('.product-price')?.querySelector('.launch-price');
    }

    connectedCallback() {
        // Wait for DOPP API to be ready
        if (window.RegiosDOPP?.api?.v0) {
            this.fetchDiscount(window.RegiosDOPP.api.v0);
        } else {
        window.addEventListener('regios-dopp:api-initialized', (event) => {
            this.fetchDiscount(event.detail.api);
        });
        }
    }

    setLaunchPrice() {
        const launchPriceEnd = this.launchPrice.getAttribute('data-launch-price-end');
        const inner = this.launchPrice.querySelector('[launch-price-inner]');

        if (
            launchPriceEnd &&
            inner
        ) {
            inner.textContent = `${inner.getAttribute('data-launch-price-text')} ${launchPriceEnd}`;
            this.launchPrice.classList.add('visible');
            this.launchPrice.closest('.product-price')?.classList.add('on-sale')
        }
    }

    async fetchDiscount(api) {
        const productId = parseInt(this.dataset.productId);
        const variantId = parseInt(this.dataset.variantId);
        const regularPriceInCents = parseInt(this.dataset.regularPriceCents);

        if (!productId || !variantId || !regularPriceInCents) {
        console.warn('custom-price: missing data attributes');
        return;
        }

        try {
        const { salePrice, regularPrice } = await api.calculateDiscountedPrices({
            productId,
            variantId,
            regularPriceInCents,
        });

        const discountAmount = regularPrice.amount - salePrice.amount;

        //let price = salePrice.formatted;
        let price = parseFloat(salePrice.amount);

        let formattedPrice;

        if (Number.isInteger(price)) {
        // whole number → show without decimals
        formattedPrice = price.toString();
        } else {
        // float → keep 2 decimals
        formattedPrice = price.toFixed(2);
        }

        // Remove trailing .00 or ,00 before optional currency letters/spaces
        //price = price.replace(/([.,])00(?=\s*[^\d\s]*)/u, "").trim();

        this.regularPriceEl.textContent = formattedPrice + " " + Theme.store.currency;
        if(discountAmount > 0 && this.regularPriceEl){
            this.classList.add('discounted-product-item');

            if(this.launchPrice) {
                this.setLaunchPrice();
            }

            if(this.querySelector('.original-price')){
                this.querySelector('.original-price').textContent = regularPrice.amount + " " + Theme.store.currency;
            }

            //badge
            const productItem = this.closest('.product-card');
            if(!productItem) return;

            const badge = productItem.querySelector('.product-card-badge');
            badge.classList.add('visible');
            badge.querySelector('.product-card-badge-text').classList.add('on-sale');
            const badgeText = badge.querySelector('.on-sale-badge-text');
            if(badgeText){
                badgeText.textContent =  `Save ${Math.floor((discountAmount) * 100 / regularPrice.amount)}%`;
            }         
        }
        } catch (err) {
        console.error('custom-price: DOPP calculation error:', err);
        }
    }
}

if (!customElements.get('custom-price')) {
  customElements.define('custom-price', CustomPrice);
}